import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-64">
    <App data-id="element-65" />
  </React.StrictMode>);